module.exports = __webpack_public_path__ + "static/media/hoodie-man-front-min.99eb562e.png";